"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHairDryerOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M9.3 7.5a1.8 1.8 0 11-3.6 0 1.8 1.8 0 013.6 0z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.1 7.5a5.4 5.4 0 015.4-5.4c3.046 0 6.302.86 9.312 1.654l.065.017.838.22 1.43-.893c1.2-.75 2.755.112 2.755 1.526v5.752c0 1.414-1.555 2.276-2.754 1.527l-1.43-.894-.839.22-.026.007c-1.762.465-3.602.95-5.424 1.276l1.404 6.08a2.7 2.7 0 11-5.262 1.215l-1.648-7.142A5.402 5.402 0 012.101 7.5zm5.4-3.6a3.6 3.6 0 00-.662 7.14l.58.107 1.905 8.255a.9.9 0 001.754-.405l-1.84-7.97.968-.14c2.022-.293 4.112-.844 6.213-1.398.407-.107.815-.215 1.22-.32l.374-.097 2.088 1.304V4.624L18.012 5.93l-.374-.098c-.405-.105-.812-.212-1.22-.32-3.083-.813-6.128-1.61-8.918-1.61z' }))); };
exports.default = SvgHairDryerOutline;
//# sourceMappingURL=HairDryerOutline.js.map